import forIn from 'lodash/forIn';
import Router, { withRouter } from 'next/router';
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { changeOrder, changePage, changePerPage } from './actions';
import {
  makeSelectError,
  makeSelectLoading,
  makeSelectOrderBy,
  makeSelectPage,
  makeSelectPerPage,
  makeSelectPhotos,
  makeSelectQuery,
  makeSelectSuggestion,
  makeSelectTotalItem,
  makeSelectTotalPage,
} from './selectors';
import Gallery from '~/components/Gallery';
import GalleryIllust from '~/components/Gallery/GalleryIllust';
import I18nLink from '~/components/I18nLink';
import LoadingSpinner from '~/components/loading-spinner/LoadingSpinner';
import NextPageButton from '~/components/NextPageButton';
import Pagination from '~/components/Pagination';
import TagDetailCover from '~/components/TagDetailCover';
import Config, { keyConfig } from '~/config';
import {
  makeSelectIsAuthenticated,
  makeSelectProfile,
} from '~/containers/AuthProvider/selectors';
import { makeSelectCurrentLang } from '~/containers/MetadataProvider/selectors';
import { loadDataSearch } from '~/containers/Search/actions';
import { searchPhoto } from '~/containers/SearchResultPage/actions';

const roles = Config.getRoles();

@withRouter
class TagDetailContainer extends React.Component {
  componentDidMount() {
    const { query } = Router.router;
    const category = [];
    const excludeCategory = [];
    const { categories } = this.props;

    if (query.category) {
      const categoryIds = query.category.split(',');
      categoryIds.map((id) =>
        category.push(categories.find((item) => item.value == id)),
      );
    }

    if (query.excludeCategory) {
      const categoryIds = query.excludeCategory.split(',');
      categoryIds.map((id) =>
        excludeCategory.push(categories.find((item) => item.value == id)),
      );
    }

    this.props.loadDataSearch({
      ...query,
      keyword: query.keyword,
      excludeKeyword: query.excludeKeyword,
      category,
      excludeCategory,
    });
  }

  onNextPage = () => {
    let currentPage = this.props.page;
    if (currentPage >= this.props.totalPage) {
      return {};
    }
    currentPage++;

    let asPath = `page=${currentPage}`;
    forIn(this.props.query, (value, key) => {
      if (
        value &&
        key !== 'page' &&
        key !== 'is_tag' &&
        key !== 'keyword' &&
        key !== 'token' &&
        key !== 'clientIp'
      ) {
        asPath += `&${key}=${value}`;
      }
    });

    return {
      as: `/search/${this.props.query.keyword}?${asPath}`,
      query: { ...this.props.query, page: currentPage },
    };
  };

  onChangePage = (page) => {
    this.props.changePage(page);
  };

  pickUpCoverImage = () => {
    const currentListCovers = Config.listCoverImages[Config.serviceType];
    let max = 5;
    switch (Config.serviceType) {
      case 'photo_ac':
        max = 14;
        break;
      case 'illust_ac':
        max = 4;
        break;
      case 'silhouette_ac':
        max = 6;
        break;
      case 'design_ac':
        max = 4;
        break;
    }
    return currentListCovers[Math.floor(Math.random() * (max - 1) + 1)];
  };

  renderError = () => {
    const { t, currentLang, isAuthenticated, profile, error } = this.props;
    console.log('--- renderError ---');
    if (
      error &&
      error.status === 401 &&
      (!isAuthenticated || profile.role === roles.FREE_MEMBER)
    ) {
      const messageKey = isAuthenticated
        ? 'search_limit_one_day'
        : 'search_limit_one_day_guest';
      return (
        <div className="search-limit-error">
          <div
            style={{ padding: '50px 30px', fontSize: 20, fontWeight: 500 }}
            className={`text-center ${Config.getPrefixContent('text-color')}`}
            dangerouslySetInnerHTML={{
              __html: t(messageKey, {
                currentLang,
                ssoLoginURL: `${
                  Config.ssoServerUrl
                }/login?lang=${currentLang}&serviceURL=${encodeURIComponent(
                  process.browser ? window.location.href : '',
                )}`,
              }),
            }}
          />
          {/* <PremiumPromotion /> */}
          {isAuthenticated && (
            <div style={{ textAlign: 'center', marginBottom: 24 }}>
              <I18nLink language={currentLang} href="/premium">
                <a>
                  <img
                    src={`/static/assets/image/not-found/${Config.serviceType}.png`}
                    className="img-limit-search"
                    alt="Search limit error"
                  />
                </a>
              </I18nLink>
            </div>
          )}
        </div>
      );
    }

    return (
      <div className="search-limit-error">
        <div
          style={{ padding: '50px 30px', fontSize: 20, fontWeight: 500 }}
          className={`text-center ${Config.getPrefixContent('text-color')}`}
          dangerouslySetInnerHTML={{ __html: t('default_error_description') }}
        />
      </div>
    );
  };

  render() {
    const {
      photos,
      currentLang,
      totalPage,
      error,
      t,
      query,
      totalItem,
      loading,
      suggest,
    } = this.props;
    const { order_by: orderBy, page, per_page: perPage, keyword } = query;
    const defaultPhoto = this.pickUpCoverImage();

    return (
      <div>
        {!error ? (
          <div>
            {
              <div className="tag-detail-page bg-gray">
                {!loading && photos.length > 0 ? (
                  <div>
                    <div className="detail-tag-cover">
                      <TagDetailCover
                        t={t}
                        backgroundImageUrl={defaultPhoto.image}
                        keyword={query.keyword}
                        searchNumber={totalItem}
                        serviceType={Config.serviceType}
                        suggestedList={suggest}
                      />
                    </div>
                    <div className="container-fluid">
                      <>
                        {Config.isIllustAC() && (
                          <GalleryIllust
                            images={photos}
                            currentLang={currentLang}
                            lastRowHide={false}
                            showImageActions
                            toggleFilterSearch={false} //fake = true to reduce count image in row
                            isNotFullWidthCustom={false} // fake = true to reduce count image when not full 100vw
                          />
                        )}
                        {!Config.isIllustAC() && (
                          <Gallery
                            images={photos}
                            currentLang={currentLang}
                            lastRowHide={false}
                            rowHeight={244}
                            showImageActions
                          />
                        )}
                      </>
                      <div className="btn-navigation">
                        <NextPageButton
                          pathname={`/search/${keyword}`}
                          query={this.onNextPage().query}
                          as={this.onNextPage().as}
                          t={t}
                        />
                        <Pagination
                          currentPage={+page}
                          totalPage={+totalPage}
                          onChange={this.onChangePage}
                          query={query}
                          path={`/search/${keyword}`}
                          asPath={`/search/${keyword}`}
                        />
                      </div>
                    </div>
                  </div>
                ) : (
                  <LoadingSpinner />
                )}

                {!loading && photos.length < 1 ? (
                  <div
                    style={{ padding: '15px 0' }}
                    className="text-center"
                    dangerouslySetInnerHTML={{
                      __html: t(keyConfig.get('no_result_search_page')),
                    }}
                  />
                ) : null}
              </div>
            }
          </div>
        ) : (
          <div>
            <div
              style={{ padding: '50px 30px', fontSize: 20, fontWeight: 500 }}
              className={`text-center ${Config.getPrefixContent('text-color')}`}
              dangerouslySetInnerHTML={{
                __html: t('search_limit_one_day_guest', {
                  currentLang,
                  ssoLoginURL: `${
                    Config.ssoServerUrl
                  }/login?lang=${currentLang}&serviceURL=${encodeURIComponent(
                    process.browser ? window.location.href : '',
                  )}`,
                }),
              }}
            />
            <div style={{ textAlign: 'center' }}>
              <I18nLink href="/premium">
                <a>
                  <img
                    src={`/static/assets/image/not-found/${Config.serviceType}.png`}
                    className="img-limit-search"
                    alt="Not found"
                  />
                </a>
              </I18nLink>
            </div>
          </div>
        )}
        <style jsx>
          {`
            .tag-detail-page .container-fluid {
              padding-top: 15px;
            }
            .btn-navigation {
              display: flex;
              justify-content: space-between;
              margin: 10px 0;
              align-items: center;
            }
          `}
        </style>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  photos: makeSelectPhotos(),
  suggest: makeSelectSuggestion(),
  currentLang: makeSelectCurrentLang(),
  error: makeSelectError(),
  page: makeSelectPage(),
  totalPage: makeSelectTotalPage(),
  totalItem: makeSelectTotalItem(),
  orderBy: makeSelectOrderBy(),
  perPage: makeSelectPerPage(),
  loading: makeSelectLoading(),
  query: makeSelectQuery(),
  isAuthenticated: makeSelectIsAuthenticated(),
  profile: makeSelectProfile(),
});

const mapDispatchToProps = (dispatch) => ({
  loadDataSearch: (query) => dispatch(loadDataSearch(query)),
  changeOrder: (value) => dispatch(changeOrder(value)),
  changePage: (page) => dispatch(changePage(page)),
  changePerPage: (value) => dispatch(changePerPage(value)),
  searchPhoto: (value) => dispatch(searchPhoto(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TagDetailContainer);
